import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { matchesFilters } from './dashboardUtils';

const DashboardStatCard = ({ title, dataUrl, filters, expanded, onToggle }) => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        let isMounted = true;

        axios
            .get(dataUrl)
            .then((response) => {
                if (isMounted) {
                    setRows(response.data.rows || []);
                }
            })
            .catch(() => {
                if (isMounted) {
                    setFailed(true);
                }
            })
            .finally(() => {
                if (isMounted) {
                    setLoading(false);
                }
            });

        return () => {
            isMounted = false;
        };
    }, [dataUrl]);

    const count = rows.filter((row) => matchesFilters(row, filters)).length;

    return (
        <div className="col-md-6 dashboard-stat-col position-relative text-center">
            <button
                type="button"
                className={`btn btn-sm position-absolute ${expanded ? 'btn-cw-primary' : 'btn-outline-cw-primary'}`}
                style={{ top: '1rem', right: '1rem' }}
                title={expanded ? 'Hide details' : 'Show details'}
                onClick={onToggle}
            >
                <i className={`fas fa-${expanded ? 'compress' : 'expand'}`}></i>
            </button>

            <h6
                className="text-uppercase text-muted font-weight-bold small mb-2 px-5"
                style={{ letterSpacing: '.03em' }}
                title={title}
            >
                {title}
            </h6>

            <div className="d-flex align-items-center justify-content-center">
                {loading && <span className="text-muted"><i className="fas fa-circle-notch fa-spin mr-2"></i>Loading&hellip;</span>}
                {!loading && failed && <span className="text-danger"><i className="fas fa-exclamation-triangle mr-2"></i>Failed to load</span>}
                {!loading && !failed && <h2 className="mb-0">{count}</h2>}
            </div>
        </div>
    );
};

export default DashboardStatCard;
